import {applyMiddleware, createStore} from "redux";
import rootReducer from "./reducers/rootReducer";
import thunk from "redux-thunk";
import {createLogger} from "redux-logger";

const logger = createLogger();

const store = createStore(rootReducer,
	applyMiddleware(logger)
	//applyMiddleware(thunk)
);

export default store;



// WEBPACK FOOTER //
// ./src/js/store.js